import { Message } from "../types/MessageListType";
import { isRealMessage } from "./messageListWindow";

export type MessageListEntry =
  | { kind: "message"; message: Message }
  | { kind: "group"; grouped_id: string; messages: Message[] };

/**
 * Collapse consecutive album members with the same grouped_id into one entry
 * (TG MessageGroupEntry). Date dividers stay as single messages.
 */
export function groupMessagesForView(records: Message[]): MessageListEntry[] {
  const out: MessageListEntry[] = [];
  const byGroup = new Map<string, Message[]>();

  for (const msg of records) {
    if (!isRealMessage(msg) || msg.message_type === "date") {
      flushPending(out, byGroup);
      out.push({ kind: "message", message: msg });
      continue;
    }

    const gid = msg.grouped_id != null ? String(msg.grouped_id) : "";
    if (!gid) {
      flushPending(out, byGroup);
      out.push({ kind: "message", message: msg });
      continue;
    }

    const bucket = byGroup.get(gid);
    if (bucket) {
      bucket.push(msg);
    } else {
      // If we already emitted something, keep order: start new pending group
      flushPending(out, byGroup);
      byGroup.set(gid, [msg]);
    }
  }
  flushPending(out, byGroup);

  // Finalize groups: sort by grouped_index, emit single if only one arrived
  return out.map((entry) => {
    if (entry.kind !== "group") return entry;
    const sorted = [...entry.messages].sort(
      (a, b) =>
        (Number(a.grouped_index) || 0) - (Number(b.grouped_index) || 0),
    );
    if (sorted.length === 1) {
      return { kind: "message", message: sorted[0] };
    }
    return { kind: "group", grouped_id: entry.grouped_id, messages: sorted };
  });
}

function flushPending(
  out: MessageListEntry[],
  byGroup: Map<string, Message[]>,
) {
  for (const [gid, msgs] of byGroup) {
    out.push({ kind: "group", grouped_id: gid, messages: msgs });
  }
  byGroup.clear();
}
